import React from "react";
import { View, Text, Image, Animated } from "react-native";

import logo from '../../../../assets/kingdom-bible-quiz-logo-transparent.png';
import { useAppTheme } from '../../../design-system/ThemeProvider';
import { useLanguageStore } from "../../../features/quiz-core/languageStore";
import { t } from "../../../i18n/translations";
import { createAuthStyles } from "../AuthScreen.styles";
import { uiText } from '../../utils/uiText';

interface LogoHeaderProps {
  logoAnim: Animated.Value;
  mode: "login" | "signup";
}

const LogoHeader: React.FC<LogoHeaderProps> = ({ logoAnim, mode }) => {
  const { colors } = useAppTheme();
  const styles = createAuthStyles(colors);
  const { language } = useLanguageStore();
  
  return (
    <View style={styles.headerSection}>
      {/* <Animated.View
        style={{
          opacity: logoAnim,
          transform: [
            {
              translateY: logoAnim.interpolate({
                inputRange: [0, 1],
                outputRange: [40, 0],
              }),
            },
          ],
        }}
      >
        <View style={styles.logoContainer}>
          <Image
            source={logo}
            style={styles.responsiveLogo}
            accessibilityLabel={uiText('logoAlt')}
          />
        </View>
      </Animated.View> */}
      <Text style={styles.headerSubtitle}>
        {mode === 'login' ? (
          <>{t('auth.welcomeBack', language)}<Text style={{ color: '#4F46E5', fontSize: 18 }}> ✨</Text></>
        ) : (
          <>{t('auth.joinKingdom', language)}<Text style={{ color: '#4F46E5', fontSize: 18 }}> ✨</Text></>
        )}
      </Text>
    </View>
  );
};

export default LogoHeader;
